<template>
  <div class="list">
    <p>{{fields[name].name}}</p>
    <textarea :class="{error: fields[name].errorId}" v-model="fields[name].value" @blur="isEmpty" @keydown="removeError" cols="30" rows="10"></textarea>
    <div class="invalid_text" v-if="fields[name].errorId">{{fields[name].errors[fields[name].errorId]}}</div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapState} = createNamespacedHelpers('mainPage')

  export default {
    props: ['name'],
    computed: {
      ...mapState([
        'fields',
        'currentTabId'
      ])
    },
    methods: {
      ...mapMutations([
        'setField'
      ]),
      isEmpty () {
        if (!this.fields[this.name].value && !this.fields[this.name].isNullable) {
          this.setField({fieldId: this.name, fieldPropertyId: 'errorId', value: 'empty'})
        }
      },
      removeError () {
        if (!this.fields[this.name].value) {
          this.setField({fieldId: this.name, fieldPropertyId: 'errorId', value: null})
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/create-form/TextArea.vue